(function () {
    'use strict';

    angular
        .module('app')
        .controller('SchoolEditController', SchoolEditController);

    SchoolEditController.$inject = ['debug', '$stateParams', 'API', 'alert', 'i18n', '$scope', '$state', 'helpers',];

    function SchoolEditController(debug, $stateParams, API, alert, i18n, $scope, $state, helpers) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.save = save;
        vm.school = {};
        vm.schoolTeachers = [];
        vm.loadingState = {
            'schoolIsLoading': false,
            'schoolUsageIsLoading': false,
            'teachersAreLoading': false,
        };
        vm.contracts = [];
        vm.groups = [];
        vm.teachers = [];

        vm.schoolUsage = {
            labels: [],
            data: [],
        };

        vm.notEditable = false;

        vm.newContractConnectionId = null;
        vm.isCreatingNewContractConnection = false;
        vm.isSavingNewContractConnection = false;
        vm.newContractConnectionValid = false;
        vm.exportSchoolUrl = '';
        vm.resourceExpand = 'contracts,groups,groups.adults';

        vm.now = helpers.getDatabaseDatetime();

        vm.newContractConnection = newContractConnection;
        vm.saveNewContractConnection = saveNewContractConnection;
        vm.openDisconnectContractModal = openDisconnectContractModal;
        vm.openRemoveModal = openRemoveModal;
        vm.openMergeModal = openMergeModal;
        vm.confirmVerifySchool = confirmVerifySchool;
        vm.addGroupToSchool = addGroupToSchool;
        vm.addTeacherToSchool = addTeacherToSchool;
        vm.addContract = addContract;

        activate();

        function activate() {
            $scope.$watch('vm.newContractConnectionId', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue && newValue > 0) {
                    var connected = false;
                    vm.contracts.forEach(function (element) {
                        if (newValue === element.id) {
                            connected = true;
                        }
                    });
                    if (!connected) {
                        vm.newContractConnectionValid = true;
                    }
                } else {
                    vm.newContractConnectionValid = false;
                }
            });
            vm.exportSchoolUrl = API.getApiUrl() + '/admin-export/school/' + vm.id + '/';
            loadSchool();
            loadSchoolUsage();
        }

        function addContract() {
            $state.go('contracts.add', { schoolId: vm.id, schoolName: vm.school.name });
        }

        function addTeacherToSchool() {
            $state.go('users.add', {
                schoolId: vm.id,
                userType: 'teacher',
             });
        }

        function addGroupToSchool() {
            $state.go('groups.add', { schoolId: vm.id });
        }

        function confirmVerifySchool() {
            var promise = alert.confirm('verify-school', { school: vm.school });

            promise.then(function() {
                vm.school.status = 'verified';
                save();
            }, function() {
                debug.log('Canceled school verification.');
            });
        }

        function loadSchool() {
            vm.loadingState.schoolIsLoading = true;
            API.School.get({ id: vm.id, expand: vm.resourceExpand }).$promise.then(function (response) {
                debug.log(response);
                vm.school = response;
                vm.contracts = angular.copy(response.contracts);
                vm.groups = angular.copy(response.groups);
                angular.forEach(vm.groups, function(group) {
                    group.teacherInitials = [];
                    if (group.adults) {
                        angular.forEach(group.adults, function(adult) {
                            group.teacherInitials.push({
                                id: adult.id,
                                initials: String(adult.first_name.charAt(0) + adult.last_name.charAt(0)).toUpperCase()
                            });
                        });
                    }
                });
                vm.notEditable = Boolean(response.fk_third_party_entity_id);
                loadTeachers();
            }, function () {})
            .finally(function() {
                vm.loadingState.schoolIsLoading = false;
            });
        }

        function loadTeachers() {
            vm.loadingState.teachersAreLoading = true;

            var promise = API.User.search({
                fk_school_id: vm.id,
                user_type: 'teacher',
                expand: 'groups',
                page: 1,
                // Limit per-page to avoid crashing browser on look at "Hemanvändare"
                'per-page': 1000,
            }).$promise;

            promise.then(function(response) {
                vm.teachers = response.items;
                vm.teachers.sort(sortTeachersBasedOnGroups);
            }, function(response) {
                window.toast({ message: i18n.get('COULD_NOT_LOAD_SCHOOL_TEACHERS'), autoRemoveTime: 5000, type: 'danger' });
                debug.log(response);
            })
            .finally(function() {
                vm.loadingState.teachersAreLoading = false;
            });

        }

        function loadSchoolUsage() {
            vm.loadingState.schoolUsageIsLoading = true;

            var promise = API.School.usage({ id: vm.id }).$promise;
            promise.then(function (response) {
                angular.forEach(response, function (day) {
                    vm.schoolUsage.labels.push(day.date);
                    vm.schoolUsage.data.push(day.count);
                });
                vm.loadingState.schoolUsageIsLoading = false;
            }, function () {
                vm.loadingState.schoolUsageIsLoading = false;
            });
        }

        function newContractConnection() {
            vm.isCreatingNewContractConnection = true;
        }

        function openDisconnectContractModal(contractId) {
            var promise = alert.confirm('disconnect-something');
            promise.then(function () {

                var promise = API.Contract.disconnectSchool({
                    id: contractId,
                    schoolId: vm.id
                }).$promise;

                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadSchool();
                }, function (response) {
                    window.toast({ message: i18n.get('FAILED'), type: 'danger' });
                    debug.error(response);
                });
            }, function () {
                debug.log('Closing modal');
            });
        }

        function openMergeModal() {
            alert.prompt('merge-school', { school: vm.school });
        }

        function openRemoveModal() {
            var promise = alert.confirm('remove-item');

            promise.then(function() {
                var removePromise = API.School.recycle({ id: vm.id }).$promise;

                removePromise.then(function() {
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('SCHOOL_RECYCLED') });
                    $state.go('schools.list');
                }, function() {});
            }, function() {});
        }

        function save() {
            if (!vm.isSaving) {
                vm.isSaving = true;

                var promise = vm.school.$save({ expand: vm.resourceExpand });

                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    vm.now = helpers.getDatabaseDatetime();
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.isSaving = false;
                });
            }
        }

        function saveNewContractConnection() {
            if (!vm.isSavingNewContractConnection) {
                vm.isSavingNewContractConnection = true;
                var promise = API.Contract.connectSchool({
                    id: vm.newContractConnectionId,
                    schoolId: vm.id
                }).$promise;

                promise.then(function (response) {
                    debug.log(response);
                    vm.isSavingNewContractConnection = false;
                    vm.isCreatingNewContractConnection = false;
                    vm.newContractConnectionValid = false;
                    if (response) {
                        window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    } else {
                        window.toast({ message: i18n.get('FAILED'), type: 'danger' });
                    }
                    loadSchool();
                }, function (response) {
                    debug.error(response);
                    window.toast({ message: i18n.get('FAILED'), type: 'danger' });
                });
            }
        }

        function sortTeachersBasedOnGroups(a, b) {
            return b.groups.length - a.groups.length;
        }
    }
})();